export const lightColor = "#fcfcfc"
export const darkColor = "#000000ff"
